import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold mb-8 text-primary">Ochrana osobných údajov</h1>

          <div className="prose prose-slate max-w-none space-y-6 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Úvod</h2>
              <p>
                Táto Ochrana osobných údajov platí pre dve skupiny používateľov:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li><strong>Firemní zákazníci</strong> - podnikatelia, ktorí používajú našu SaaS platformu TagInn na riadenie svojho podnikania</li>
                <li><strong>Koncový používatelia</strong> - zákazníci našich firemných zákazníkov (napr. ľudia, ktorí získavajú vernostné karty, podávajú recenzie, prihlášky na pracovné pozície atď.)</li>
              </ul>
              <p className="mt-4">
                Prevádzkovateľom služby <strong>TagInn</strong> (ďalej len "Správca") je subjekt uvedený v sekcii Kontakt. Spracovanie osobných údajov prebieha v zmysle zákona č. 18/2018 Z. z. o ochrane osobných údajov a Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 (GDPR).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">1. Osobné údaje firemných zákazníkov</h2>
              <h3 className="text-xl font-semibold mt-4 mb-3">Aké údaje zbierame:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno a priezvisko</li>
                <li>Názov spoločnosti (ak ide o podnikateľa)</li>
                <li>Adresa</li>
                <li>E-mailová adresa</li>
                <li>Telefonické číslo</li>
                <li>IČO a DIČ (v prípade firemných zákazníkov)</li>
                <li>Údaje o používaní služby (analytické dáta)</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Účel spracovania:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Poskytovanie SaaS služieb pre správu podnikania</li>
                <li>Evidencia a správa zákazníckych účtov</li>
                <li>Komunikácia a technická podpora</li>
                <li>Vystavovanie faktúr a vedenie účtovníctva</li>
                <li>Zasielanie marketingových informácií (len so súhlasom)</li>
                <li>Zlepšovanie kvality poskytovaných služieb</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Doba uchovávania:</h3>
              <p>Údaje budú spracované po dobu trvania zmluvného vzťahu a následne po dobu 10 rokov v súlade s požiadavkami zákona o účtovníctve a daňových predpisov.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">2. Osobné údaje koncových používateľov</h2>
              <p className="mb-4">
                Keď používate funkcie poskytované našimi firemných zákazníkmi (napríklad vernostné programy, podávanie recenzií, prihlášky na pracovné pozície), môžeme zbierať nasledujúce údaje:
              </p>

              <h3 className="text-xl font-semibold mt-4 mb-3">Vernostné programy a digitálne karty:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>E-mailová adresa (povinné)</li>
                <li>Meno a priezvisko (voliteľné)</li>
                <li>Telefónne číslo (voliteľné)</li>
                <li>Dátum narodenia (voliteľné)</li>
                <li>História transakcie a získané body</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Recenzie a hodnotenia:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno (voliteľné)</li>
                <li>E-mailová adresa (voliteľné, na účely odmien)</li>
                <li>Hodnotenie a obsah recenzie</li>
                <li>Odpovede na vlastné otázky</li>
                <li>ID relácie (na účely analytiky)</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Pracovné prihlášky:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno a priezvisko</li>
                <li>E-mailová adresa a telefónne číslo</li>
                <li>Adresa bydliska</li>
                <li>Dátum narodenia</li>
                <li>Životopis a motivačný list (súbory)</li>
                <li>Pracovná história a vzdelanie</li>
                <li>Referencie (mená, telefóny, e-maily)</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Registrácie na podujatia:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno a priezvisko</li>
                <li>E-mailová adresa a telefónne číslo</li>
                <li>Stravovacie preferencie</li>
                <li>Núdzový kontakt</li>
                <li>Poznámky</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Kupóny a zľavové akcie:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno a e-mailová adresa</li>
                <li>História uplatnenia kupónov</li>
                <li>ID digitálnej peňaženky (Google Wallet, Apple Wallet)</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Kontaktné formuláre:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meno</li>
                <li>E-mailová adresa</li>
                <li>Telefónne číslo (voliteľné)</li>
                <li>Obsah správy</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Účel spracovania koncových údajov:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Poskytovanie vernostných programov a odmien</li>
                <li>Zasielanie digitálnych kariet do peňaženky</li>
                <li>Spracovanie recenzií a hodnotení</li>
                <li>Spracovanie pracovných prihlášok a náborový proces</li>
                <li>Organizácia podujatí a komunikácia s účastníkmi</li>
                <li>Spracovanie kupónov a zľavových akcií</li>
                <li>Odpovede na kontaktné formuláre</li>
                <li>Analytika a zlepšovanie služieb</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Doba uchovávania koncových údajov:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Vernostné programy:</strong> Po dobu aktívneho členstva + 2 roky po poslednej aktivite</li>
                <li><strong>Recenzie:</strong> Pokiaľ nie sú vymazané na žiadosť alebo podnikateľom, po dobu prevádzky služby</li>
                <li><strong>Pracovné prihlášky:</strong> 2 roky od podania prihlášky (ak neboli vybrané), alebo počas zamestnania + 10 rokov (ak boli vybraté)</li>
                <li><strong>Registrácie na podujatia:</strong> 1 rok po ukončení podujatia</li>
                <li><strong>Kupóny:</strong> 3 roky od uplatnenia</li>
                <li><strong>Kontaktné formuláre:</strong> 2 roky od odoslania</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Kto má prístup k vašim údajom:</h3>
              <p className="mb-4">
                Vaše osobné údaje môžu byť viditeľné nasledujúcim osobám, vždy iba v rozsahu nevyhnutnom na poskytovanie služby:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Majiteľ podniku</strong> - Má prístup k vašim úplným údajom (meno, email, telefón) na účely správy vernostného programu, spracovania prihlášok, organizácie podujatí a komunikácie s vami</li>
                <li><strong>Zamestnanci podniku</strong> - Pri overovaní vernostnej karty môžu vidieť vaše meno, aby vás mohli identifikovať a pripísať body. Nevidia váš email ani telefón.</li>
                <li><strong>Správcovia systému TagInn</strong> - Máme technický prístup k údajom výhradne na účely technickej podpory a riešenia problémov, vždy len so súhlasom podnikateľa</li>
              </ul>

              <p className="mt-6 bg-muted p-4 rounded-lg">
                <strong>Dôležité:</strong> Vaše údaje sú spracovávané v mene podnikateľa, ktorého služby používate.
                Ak máte otázky alebo chcete využiť svoje práva týkajúce sa údajov, môžete sa obrátiť priamo na tohoto
                podnikateľa alebo na nás pomocou kontaktných údajov uvedených nižšie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">3. Spracovanie osobných údajov</h2>
              <p>
                Súhlasom so spracovaním osobných údajov udeľuje dotknutá osoba svoj výslovný súhlas
                s vyššie uvedeným spracovaním. Súhlas možno vziať kedykoľvek späť, a to:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Zaslaním emailu na adresu: <a href="mailto:info@taginn.app" className="text-primary hover:underline">info@taginn.app</a></li>
                <li>Telefonicky na čísle: +421 902 691 939</li>
              </ul>

              <p className="mt-6">
                Spracovanie osobných údajov je vykonávané Správcom. Osobné údaje môžu spracovávať
                aj títo spracovatelia:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Poskytovateľ webhostingu a cloudových služieb (Supabase Inc.)</li>
                <li>Poskytovateľ platobných služieb (Stripe) - pripravované na budúce použitie</li>
                <li>Poskytovateľ emailových služieb (Resend)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">4. Práva dotknutej osoby</h2>
              <p>
                Podľa zákona o ochrane osobných údajov a GDPR má každá osoba (firemní zákazníci aj koncoví používatelia) právo:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li><strong>Vziať súhlas kedykoľvek späť</strong> - bez toho, aby to malo vplyv na zákonnosť spracovania založeného na súhlase pred jeho odvolaním</li>
                <li><strong>Vyžiadať od nás informáciu</strong>, aké vaše osobné údaje spracovávame</li>
                <li><strong>Vyžiadať od nás vysvetlenie</strong> ohľadne spracovania osobných údajov</li>
                <li><strong>Vyžiadať si u nás výpis</strong> týchto údajov a tieto nechať aktualizovať alebo opraviť</li>
                <li><strong>Požadovať od nás vymazanie</strong> týchto osobných údajov (právo "byť zabudnutý")</li>
                <li><strong>Požadovať obmedzenie spracovania</strong> vašich osobných údajov</li>
                <li><strong>Namietať voči spracovaniu</strong> osobných údajov</li>
                <li><strong>Požadovať prenos údajov</strong> inému správcovi</li>
                <li><strong>Podať sťažnosť</strong> na Úrad na ochranu osobných údajov Slovenskej republiky</li>
              </ul>

              <div className="mt-6 bg-primary/10 p-4 rounded-lg border-l-4 border-primary">
                <h3 className="font-semibold mb-2">Pre koncových používateľov:</h3>
                <p className="text-sm">
                  Ak ste zákazníkom niektorého z našich firemných zákazníkov (napr. máte vernostnú kartu, podali ste recenziu alebo prihlášku na prácu), vaše údaje môžete:
                </p>
                <ul className="list-disc pl-6 mt-2 text-sm space-y-1">
                  <li><strong>Zobraziť a upraviť</strong> - Kontaktujte podnikateľa, ktorého služby ste používali</li>
                  <li><strong>Vymazať</strong> - Požiadajte o vymazanie kontaktovaním nás na email uvedený nižšie</li>
                  <li><strong>Stiahnuť</strong> - Požiadajte o export vašich údajov</li>
                </ul>
                <p className="text-sm mt-3">
                  <strong>Ako požiadať o vymazanie údajov:</strong><br/>
                  Pošlite email na <a href="mailto:info@taginn.app" className="text-primary hover:underline font-medium">info@taginn.app</a> s predmetom "Žiadosť o vymazanie údajov" a uveďte:
                </p>
                <ul className="list-disc pl-6 mt-2 text-sm">
                  <li>Váš email alebo telefónne číslo</li>
                  <li>Aký typ údajov chcete vymazať (napr. vernostná karta, recenzia, pracovná prihláška)</li>
                  <li>Názov podniku, s ktorým ste interagovali (ak si pamätáte)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Cookies a lokálne úložisko</h2>
              <p>
                Naša webová stránka používa súbory cookies a lokálne úložisko prehliadača na
                zabezpečenie základnej funkčnosti služby. Všetky používané cookies sú nevyhnutné
                pre prevádzku stránky.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-primary">Kategória: Nevyhnutné cookies a úložisko</h3>
              <p className="mb-4">
                Tieto cookies a údaje v lokálnom úložisku sú nutné pre základné funkcie stránky
                a sú preto vždy povolené. Stránka nemôže riadne fungovať bez týchto údajov.
              </p>

              <div className="space-y-4 mt-4">
                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">sb-mtzgsiyrjoqihggjrmqv-auth-token</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Uchovávanie prihlasovacích údajov a relácie používateľa (autentifikačné tokeny)</p>
                  <p className="text-sm"><strong>Typ:</strong> HTTP Cookie (Supabase Auth)</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Dlhodobé (refresh token) / 1 hodina (access token)</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - nevyhnutné pre autentifikáciu</p>
                </div>

                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">vite-ui-theme</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Uchovávanie preferencie témy vzhľadu (svetlá/tmavá/systémová)</p>
                  <p className="text-sm"><strong>Typ:</strong> LocalStorage</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Až do vymazania používateľom</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - funkčné nastavenie</p>
                </div>

                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">autoLogoutDuration</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Uchovávanie nastavenia automatického odhlásenia</p>
                  <p className="text-sm"><strong>Typ:</strong> LocalStorage</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Až do vymazania používateľom</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - bezpečnostné nastavenie</p>
                </div>

                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">cookie-notice-acknowledged</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Zaznamenanie zobrazenia cookie oznámenia</p>
                  <p className="text-sm"><strong>Typ:</strong> LocalStorage</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Až do vymazania používateľom</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - technické nastavenie</p>
                </div>

                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">business-dashboard-tab, employee-dashboard-tab, employee-portal-tab</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Uchovávanie poslednej zobrazenej záložky v používateľskom rozhraní</p>
                  <p className="text-sm"><strong>Typ:</strong> LocalStorage</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Až do vymazania používateľom</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - funkčné nastavenie</p>
                </div>

                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold">selectedBusinessId, selected-shift-date</h4>
                  <p className="text-sm mt-1"><strong>Účel:</strong> Uchovávanie používateľského výberu pre zjednodušenie práce s aplikáciou</p>
                  <p className="text-sm"><strong>Typ:</strong> LocalStorage</p>
                  <p className="text-sm"><strong>Trvanie:</strong> Až do vymazania používateľom</p>
                  <p className="text-sm"><strong>Súhlas potrebný:</strong> Nie - funkčné nastavenie</p>
                </div>
              </div>

              <p className="mt-6">
                <strong>Nepoužívame:</strong> Analytické cookies tretích strán (ako Google Analytics, Facebook Pixel),
                marketingové cookies, sledovacie cookies tretích strán ani cookies na cielenú reklamu.
              </p>

              <p className="mt-4 text-sm text-muted-foreground">
                <strong>Poznámka:</strong> Interná analytika formulárov (popísaná v sekcii "Interná analytika" nižšie)
                NEpoužíva cookies - údaje sú ukladané do databázy pomocou náhodne vygenerovaného ID relácie.
              </p>

              <p className="mt-4">
                Cookies môžete spravovať alebo vymazať v nastaveniach vášho prehliadača. Upozorňujeme však,
                že vypnutím nevyhnutných cookies nebude aplikácia správne fungovať a nebudete sa môcť prihlásiť.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Interná analytika</h2>
              <p>
                Pre zlepšenie používateľskej skúsenosti sledujeme kroky, ktoré používatelia
                vykonajú vo verejných formulároch (recenzie, prihlášky na prácu). Táto analytika
                je súčasťou našej vlastnej platformy a slúži výhradne na zlepšenie služieb.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Aké údaje zbierame:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>ID relácie (náhodne vygenerované, nie je spojené s vašou identitou)</li>
                <li>Kroky procesu (napr. "zobrazené hodnotenie", "odoslané hodnotenie")</li>
                <li>User agent (typ prehliadača a zariadenia)</li>
                <li>Čas vykonania kroku</li>
                <li>ID formulára a podniku (na účely štatistík)</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Účel spracovania:</h3>
              <p>
                Tieto údaje používame na:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Zlepšenie používateľskej skúsenosti a dizajnu formulárov</li>
                <li>Identifikáciu problémov v procesoch (napr. kde používatelia opúšťajú formulár)</li>
                <li>Poskytovanie štatistík podnikom o efektívnosti ich formulárov</li>
              </ul>

              <div className="mt-4 bg-primary/10 p-4 rounded-lg">
                <p className="font-semibold">Dôležité:</p>
                <p className="text-sm mt-2">
                  <strong>Nesledujeme vás naprieč webmi</strong> - analýza sa týka len interakcie s našimi formulármi.
                  <strong> Nepredávame tieto údaje tretím stranám</strong> ani ich nepoužívame na marketingové účely.
                  <strong> Nepoužívame Google Analytics</strong> ani iné externé analytické nástroje tretích strán.
                </p>
              </div>

              <h3 className="text-xl font-semibold mt-6 mb-3">Právny základ:</h3>
              <p>
                Oprávnený záujem (GDPR čl. 6 ods. 1 písm. f) - zlepšovanie kvality služieb a
                poskytovanie štatistík našim zákazníkom.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Doba uchovávania:</h3>
              <p>
                Analytické údaje uchovávame po dobu 24 mesiacov od vytvorenia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Zabezpečenie údajov</h2>
              <p>
                Prijímame primerané technické a organizačné opatrenia na ochranu vašich osobných
                údajov pred neoprávneným prístupom, zmenou, zverejnením alebo zničením. Používame
                šifrovanie SSL/TLS, bezpečné dátové centrá a pravidelné bezpečnostné audity.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Kontakt</h2>
              <p>
                V prípade akýchkoľvek otázok týkajúcich sa ochrany osobných údajov nás môžete
                kontaktovať:
              </p>
              <div className="mt-4 space-y-2">
                <p><strong>Správca osobných údajov:</strong></p>
                <p>TagInn</p>
                <p>Slovenská republika</p>
                <p>Email: <a href="mailto:info@taginn.app" className="text-primary hover:underline">info@taginn.app</a></p>
                <p>Telefón: +421 902 691 939</p>
              </div>
              <p className="mt-4 text-sm text-muted-foreground italic">
                Poznámka: Služba je momentálne poskytovaná bez poplatkov. Pri zavedení platených služieb
                budú doplnené kompletné údaje o živnosti (IČO, miesto podnikania).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">Úrad na ochranu osobných údajov</h2>
              <p>
                V prípade pochybností o dodržiavaní povinností súvisiacich so spracovaním osobných
                údajov sa môžete obrátiť na:
              </p>
              <div className="mt-4 space-y-2">
                <p><strong>Úrad na ochranu osobných údajov Slovenskej republiky</strong></p>
                <p>Hraničná 12, 820 07 Bratislava 27</p>
                <p>Tel.: +421 2 3231 3214</p>
                <p>Email: statny.dozor@pdp.gov.sk</p>
                <p>Web: <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.dataprotection.gov.sk</a></p>
              </div>
            </section>

            <p className="text-sm text-muted-foreground mt-8">
              Posledná aktualizácia: {new Date().toLocaleDateString('sk-SK')}
            </p>
          </div>

          <div className="mt-8">
            <Link to="/" className="text-primary hover:underline">
              ← Späť na hlavnú stránku
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
